<template>
  <r-simple-card title="Информация о расчете" :default-closed="true">
    <div class="calculation-info">
      <div class="calculation-info__row">
        <el-button
          type="info"
          @click="downloadFile(calculation.result.log_archive_input)"
        >
          Скачать Input Log
        </el-button>
      </div>
      <div class="calculation-info__row">
        <el-button
          type="info"
          @click="downloadFile(calculation.result.log_archive_output)"
        >
          Скачать Output Log
        </el-button>
      </div>
    </div>
  </r-simple-card>
</template>

<script>
import constants from "@/constants/url";
import { downloadFile } from "@/utils";

export default {
  props: {
    calculation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      url: constants.URL
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    downloadFile(item) {
      const file = {
        href: `${this.url}/download_share_resource/${item}?access_token=${
          this.token
        }`,
        name: "download"
      };

      downloadFile(file);
    }
  }
};
</script>

<style lang="scss">
.calculation-info {
  &__row {
    &:not(:first-child) {
      margin-top: 16px;
    }

    .el-button {
      width: 100%;
    }
  }
}
</style>
